<template>
  <div class="home">
    <div class="content-box">
     <Content></Content>
    </div>
    
    <Footer></Footer>
  </div>
</template>

<script>
import Content from './Content.vue';
import Footer from '../../components/Footer.vue';
export default {
  components: {
    Content,
    Footer
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.content-box {
  background: #fff;
  position: relative;
}
</style>
